export const normalizeDevices = (allItems, r2rInc, category) => {
  const devicesNormalized = [];
  const products = allItems?.products;
  if (products && products.length > 0) {
    products.forEach((eachProduct) => {
      const singleDevice = {};
      const { offers } = eachProduct
      if (r2rInc) {
        const r2rOffers = offers.r2rAdditional;
        if (r2rOffers && r2rOffers.length > 0) {
          let principalOffer = r2rOffers.filter((eachOffer) => (eachOffer.tags && eachOffer.tags.includes('MOVISTAR SWAP')));
          if (principalOffer.length === 0) {
            principalOffer.push(offers.r2rAdditional[0]) ;
          }
          principalOffer.forEach((eachR2rOffer) => {
            singleDevice.name = eachR2rOffer?.name;
            if (typeof eachR2rOffer.monthlyPayment48 === 'number' && eachR2rOffer.monthlyPayment48>-1) {
              singleDevice.price = eachR2rOffer?.monthlyPayment48;
            } else if (typeof eachR2rOffer.monthlyPayment36 === 'number' && eachR2rOffer.monthlyPayment36 > -1) {
              singleDevice.price = eachR2rOffer?.monthlyPayment36;
            } else if (typeof eachR2rOffer.monthlyPayment24 === 'number' && eachR2rOffer.monthlyPayment24 > -1) {
              singleDevice.price = eachR2rOffer?.monthlyPayment24;
            }
            if (eachR2rOffer?.imgs && eachR2rOffer?.imgs.length > 0) {
              singleDevice.img = eachR2rOffer?.imgs[0];
            }
            if (eachR2rOffer?.stamps && Array.isArray(eachR2rOffer.stamps) && eachR2rOffer.stamps.length > 0) {
              eachR2rOffer.stamps.forEach(({ text }) => {
                if (text) {
                  singleDevice.stamp = text;
                }
              })
            }
          })
        }
      } else {
        const r2rOffers = offers.r2r;
        if (r2rOffers && r2rOffers.length > 0) {
          let principalOffer = r2rOffers.filter((eachOffer) =>( eachOffer.tags && eachOffer.tags.includes('MOVISTAR SWAP')));
          if (principalOffer.length === 0) {
            principalOffer.push(offers.r2r[0]) ;
          }
          principalOffer.forEach((eachR2rOffer) => {
            singleDevice.aliasurl = eachR2rOffer?.aliasUrl;
            singleDevice.name = eachR2rOffer?.name;
            if (category === 'FUSION_AV') {
              if (eachR2rOffer?.pvp_fusion_av_promo !== '-') {
                singleDevice.price = eachR2rOffer?.pvp_fusion_av_promo;
              } else {
                singleDevice.price = eachR2rOffer?.pvp_fusion_av;
              }
            } else if (category === 'FUSION_MV') {
              if (eachR2rOffer?.pvp_fusion_mv_promo !== '-') {
                singleDevice.price = eachR2rOffer?.pvp_fusion_mv_promo;
              } else {
                singleDevice.price = eachR2rOffer?.pvp_fusion_mv;
              }
            } else if (eachR2rOffer?.pvp_fusion_bv_promo !== '-') {
              singleDevice.price = eachR2rOffer?.pvp_fusion_bv_promo;
            } else {
              singleDevice.price = eachR2rOffer?.pvp_fusion_bv;
            }
            if (eachR2rOffer?.imgs && eachR2rOffer?.imgs.length > 0) {
              singleDevice.img = eachR2rOffer?.imgs[0];
            }
            if (eachR2rOffer?.stamps && Array.isArray(eachR2rOffer.stamps) && eachR2rOffer.stamps.length > 0) {
              eachR2rOffer.stamps.forEach(({ text }) => {
                if (text) {
                  singleDevice.stamp = text;
                }
              })
            }
          })
        }
      }
      if (Object.keys(singleDevice).length > 0) {
        devicesNormalized.push(singleDevice);
      }
    })
  }
  return devicesNormalized;
}

export const transformPacParamsToUrlfilters = (params) => {
  let result = '';
  if (params) {
    if (params.pageSize) {
      result += `pageSize=${params.pageSize}`;
    }
    if (params.category && params.category.length > 0) {
      params.category.forEach((eachCategory) => {
        result += `&category=${eachCategory}`;
      });
    }
    if (params.query) {
      result += `&query=${params.query}`;
    }
    if (params.minStock) {
      result += `&minStock=${params.minStock}`;
    }
    if (params.maxPrice) {
      result += `&maxPrice=${params.maxPrice}`;
    }
    if (params.cl) {
      result += `&cl=${params.cl}`;
    }
    if (params.sort) {
      result += `&sort=${params.sort}`;
    }
    if (typeof params?.pageIndex === 'number') {
      result += `&pageIndex=${params.pageIndex}`;
    }
  }

  return result;
};
